const getCartItemsCount = (items) => {
    if (!Array.isArray(items)) {
        return 0;
    }
    return items.reduce((count, { quantity }) => count + (quantity || 0), 0);
};
export default getCartItemsCount;
//# sourceMappingURL=getCartItemsCount.js.map